import React from 'react'

const Learn = () => {
    return (
        <div className='flex flex-wrap md:h-screen justify-center items-center p-10 bg-yellow-50'>
            <div className="w-full md:w-5/6 overflow-hidden">
                <img src='instructions.png' alt='first demostration of the whiteboard' />
            </div>

        </div>
    )
}

export default Learn;
